/* @flow */

import * as React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import withErrorHandler from '../utils/withErrorHandler';
import withI18n from '../utils/withI18n';
import FlexBox from './FlexBox';
import Icon from './Icon';

const NoticeWrap = styled(FlexBox)`
  width: 100%;
  /* min-width: ${({ theme }) => theme.minWidth}; */
  padding: 15px 0;
  background: rgba(11, 14, 17, 1);
`;

const NoticeBox = styled(FlexBox)`
  background: rgba(240, 185, 11, 0.15);
  border-radius: 3px;
  padding: 18px 20px;
  line-height: 100%;
  font-size: 14px;
  width: ${({ theme, isBisicTradePage }) => isBisicTradePage ? theme.basictTradePageMaxWidth : theme.maxWidth};
  color: rgba(240, 185, 11, 1);
`;

const NoticeTitle = styled.p`
  padding: 0 10px;
  margin: 0;
  color: rgba(240, 185, 11, 1);
`;

const DetailLink = styled.a`
  color: #fff;
  margin-left: 30px;
  & :hover {
    color: ${({ theme }) => theme.emergencyNotice.detailLinkColor};
    text-decoration: underline;
  }
  & :visited {
    color: #fff;
  }
`;

const CloseButton = styled.span`
  cursor: pointer;
`;

const mapStateToProps = ({ news, locale }) => ({ news, locale });

type Props = {
  i18n: Object,
  news: Object,
  locale?: string,
  isBisicTradePage?: boolean,
  shouldHeaderFixed?: boolean,
  isShowEmergencyNotice?: boolean,
};

type NoticeData = {
  title: string,
  url: string,
}

type State = { noticeData: NoticeData, isShow?: boolean };

export default
@withI18n
@withErrorHandler
@connect(mapStateToProps)
class UrgentNotice extends React.Component<Props, State> {
  static defaultProps = {
    i18n: {},
    news: {},
    locale: 'en',
    isBisicTradePage: false,
    shouldHeaderFixed: false,
  };

  state = { noticeData: { title: '', url: '' }, isShow: false };

  componentDidMount() {
    this._getNoticeData();
  }

  componentDidUpdate(prevProps: Props) {
    const { news } = this.props;
    if (news !== prevProps.news) {
      this._getNoticeData();
    }
  }

  _getNoticeData = () => {
    const { news, locale } = this.props;
    const notice = {
      title: '',
      url: '',
    };
    if (!news[locale]) return; // prevent error.
    news[locale].map(item => {
      if (item.isEmergency) {
        notice.title = item.detail;
        notice.url = item.url;
        return true;
      }
      return null;
    });

    if (notice.title !== '') {
      this.setState({ isShow: true, noticeData: notice });
    }
  }

  _close = () => {
    this.setState({ isShow: false });
  };

  render() {
    const {
      i18n, isBisicTradePage, isShowEmergencyNotice,
    } = this.props;
    const { isShow, noticeData } = this.state;
    let NoticeHtml;

    if (isShow && isShowEmergencyNotice) {
      NoticeHtml = (
        <NoticeWrap justify="center">
          <NoticeBox isBisicTradePage={isBisicTradePage} justify="space-between" align="center">
            <FlexBox justify="space-between" align="center">
              <Icon type="prompt-o" color="rgba(240, 185, 11, 1)" size={23} />
              <NoticeTitle>{noticeData.title}</NoticeTitle>
              <DetailLink href={noticeData.url} target="_blank">
                {i18n['exchange-emergency-more'] || 'More'}
              </DetailLink>
            </FlexBox>
            <CloseButton onClick={this._close}>
              <Icon type="Close-x" color="rgba(240, 185, 11, 1)" size={16} />
            </CloseButton>
          </NoticeBox>
        </NoticeWrap>
      );
    } else {
      NoticeHtml = null;
    }

    return NoticeHtml;
  }
}
